import { formatCompactAge } from '@/Utils/formatCompactAge';

interface TimeInStatusWorkOrder {
    status?: { value?: string | null } | null;
    statusChangedAt?: string | null;
}

/**
 * The neutral blue "time in status" banner conveys how long an active work order has been sitting in
 * its current board status (e.g. "3d"), derived from when it last changed status. It is the lowest
 * priority of the card banners — shown only when the card is neither flagged for attention (draft)
 * nor overdue — and never on done work orders, where the elapsed time carries no meaning. Returns the
 * compact age, or '' when no banner should show (done, or no recorded status change).
 */
export const workOrderTimeInStatusAge = (workOrder: TimeInStatusWorkOrder | null | undefined): string => {
    if (!workOrder || workOrder.status?.value === 'done') {
        return '';
    }

    return formatCompactAge(workOrder.statusChangedAt);
};
